import { PageHeader, PolicyDocumentsSections } from '@korint/folio';

export const DriverDocumentsView = () => {
  return (
    <div className="space-y-8">
      <PageHeader title="Mes documents" />
      <PolicyDocumentsSections displayContext="policyholder" />
    </div>
  );
};
